/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { View } from "./View";
export const ViewResponse = core.serialization.object({
    data: View,
});
